export const isVcgScaleKey = (scaleKey) =>
  typeof scaleKey === "string" && scaleKey.trim().toLowerCase() === "vcg";

const LIMB_KEYS = [
  "upper_left_limb",
  "lower_left_limb",
  "upper_right_limb",
  "lower_right_limb",
];

export const hasVcgAssessmentInput = (data) => {
  if (!data || typeof data !== "object") return false;

  if (String(data.comments ?? "").trim().length > 0) return true;

  for (const k of LIMB_KEYS) {
    const v = data[k];
    if (v == null || v === "") continue;
    const n = typeof v === "number" ? v : Number(v);
    if (Number.isFinite(n) && n >= 1 && n <= 6) return true;
  }

  return false;
};
